'use strict';

angular.module('searchV2Module', []);
